import "./cardwithtext.css";

const CardWithText = ({
  title,
  description,
  imageSrc,
  bgColor,
  borderColor,
  height,
}) => {
  return (
    <div
      className="benefit-card"
      style={{ backgroundColor: bgColor, border: `1px solid ${borderColor}` }}
    >
      <div className="benefit-card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
      </div>
      <div className="card-boxes">
        <img src={imageSrc} alt="" />
      </div>
    </div>
  );
};

export default CardWithText;
